import { Stack } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { Item, ControlledTextInput, WsButton, WisestepLogo, Label } from 'wisestep-base';

import { AuthLayout } from '../../../components';

interface IActivationKeyForm {
  email: string;
}

const ActivationKey = () => {
  const methods = useForm<IActivationKeyForm>();

  const { handleSubmit } = methods;

  const handleActivationKey = () => null;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(handleActivationKey)}>
        <AuthLayout>
          <Item sx={{ width: '100%', padding: 20 }}>
            <Stack alignItems="center">
              <WisestepLogo />
            </Stack>
            <Stack mt={10} alignItems="center" sx={{ textDecorationWidth: 5 }}>
              <Label sx={{ fontSize: '28px', fontWeight: 'bold' }}>Resend Activation Key</Label>
            </Stack>

            <Stack mt={3} direction="column" spacing={2}>
              <ControlledTextInput
                name={'email'}
                labelText="Email Address"
                fullWidth
                id="password"
                placeholder="eg. johndoe@email.com"
                variant="outlined"
                required
                autoComplete="workspaceName"
              />
            </Stack>
            <Stack mt={2}>
              <WsButton variant="contained" size="large" fullWidth type="submit">
                Send Activation Key
              </WsButton>
            </Stack>
          </Item>
        </AuthLayout>
      </form>
    </FormProvider>
  );
};

export default ActivationKey;
